<app-header class="sticky-header"></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>